import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "modal fade",
  id: "crop-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modalLabel"
};
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document",
  ref: "modal_dialog"
};
const _hoisted_3 = {
  class: "modal-content",
  id: "crop-modal-content"
};
const _hoisted_4 = {
  class: "modal-body"
};
const _hoisted_5 = {
  key: 0,
  class: "row justify-content-center",
  style: {
    "width": "100%"
  }
};
const _hoisted_6 = {
  class: "col-4 col-md-4 col-sm-4"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "col-4 col-md-4 col-sm-4"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "col-4 col-md-4 col-sm-4"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "modal-footer"
};
const _hoisted_13 = {
  class: "row foot-btn-group"
};
const _hoisted_14 = {
  class: "col-3"
};
const _hoisted_15 = {
  class: "col-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "modal-header crop-header"
  }, [_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [_createElementVNode("span", null, "×")])], -1)), _createElementVNode("div", _hoisted_4, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "img-container",
    id: "crop-container"
  }, [_createElementVNode("img", {
    id: "crop_image",
    class: "crop_image"
  })], -1)), $props.isShowCropShape ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $props.crop_resizeSquare.image,
    class: "img-responsive modal-footer-image",
    id: "crop_resizeSquare",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onSelectSquare && $options.onSelectSquare(...args))
  }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $props.crop_horizontal.image,
    class: "img-responsive modal-footer-image",
    id: "crop_horizontal",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onSelectHorizontal && $options.onSelectHorizontal(...args))
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $props.crop_vertical.image,
    class: "img-responsive modal-footer-image",
    id: "crop_vertical",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onSelectVertical && $options.onSelectVertical(...args))
  }, null, 8, _hoisted_11)])])) : _createCommentVNode("", true)]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "corp-box-setting",
    id: "corp-box-setting"
  }, null, -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "col-6"
  }, null, -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary foot-btn",
    "data-bs-dismiss": "modal",
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.$emit('cancel'), ["stop"]))
  }, " cancel ")]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary foot-btn",
    id: "crop",
    onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.onOk && $options.onOk(...args), ["stop"]))
  }, " ok ")])])])])], 512)]);
}